export enum IconVariants {
  X_SMALL = '12px',
  SMALL = '16px',
  MEDIUM = '20px',
  LARGE = '24px',
  NONE = '',
}

export enum LoaderVariants {
  SKELETON = 'skeleton',
  SPINNER = 'spinner',
  NONE = 'none',
}

export enum IconNames {
  SEND = 'send',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_UP = 'chevron-up',
  OUTLINE_EDIT = 'edit-outline',
  CROSS_POST = 'cross-post',
  PASSWORD_EYE_CLOSE = 'password-eye-close',
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE_THROUGH = 'strike-through',
  LINK = 'link',
  NUMBERED_LIST = 'numbered-list',
  BULLETED_LIST = 'bulleted-list',
  BLOCKQUOTE = 'block-quote',
  ATTACHMENT = 'attachment',
  FACE_SMILE = 'face-smile',
  MENTION = 'mention',
  PHOTO = 'photo',
  RECORD_TAG = 'record-tag',
  FILE = 'file',
  CROSS = 'cross',
  SEARCH = 'search',
  DANGER_ALERT = 'danger-alert',
}
